import { Link } from 'react-router-dom';

export function SiteHeader() {
  return (
    <header className="mx-auto max-w-3xl px-5 pt-6 pb-4 flex items-center justify-between">
      <Link to="/" className="no-underline">
        <span className="gcm-eyebrow">Good Circle Marketing</span>
        <div className="font-heading font-bold text-text-primary text-lg leading-none mt-1">
          Content Planner
        </div>
      </Link>
      <span className="hidden sm:inline gcm-eyebrow">Spring Challenge · Day 5</span>
    </header>
  );
}
